<template>
  <div class="overview">
    <div class="overview__header text-gray-700 d-flex align-items-center bg-gray-200">
      <h5 class="font-weight-normal m-0 text-center p-3">OVERVIEW</h5>
    </div>

    <div class="overview__body bg-white d-flex flex-column justify-content-between  align-items-center">
      <div class="overview__box w-100 d-flex justify-content-between align-items-center p-4">
        <h3 class="font-weight-light">Reach</h3>
        <div>
          <h2 class="font-weight-light">{{ overviewData.reachSegmentPercentage }}</h2>
        </div>
      </div>
      <div class="overview__box w-100 d-flex justify-content-between align-items-center p-4">
        <div class="text-uppercase">
          <h1 class="font-weight-lighter text-primary">{{ overviewData.contacts }}</h1>
          <p class="text-gray-600 m-0">{{ overviewData.contactsPercentageOfTotal }} of Contacts</p>
        </div>

        <div>
          <div class="percentage-circle circle-basic" :class="`circle-${percentDunot}`">
            <span>
              <CIcon name="peopleFull" size="custom-size" class="text-gray-500 pr-1" :height="45" viewBox="0 0 32 32" />
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="overview__box w-100 p-4">
          <h3 class="font-weight-light">Balance</h3>
          <ul class="text-uppercase d-flex flex-column p-0 mt-2 mb-0 text-gray-600">
            <li class="d-flex justify-content-between"><span class="text-left">REVENUE</span><span class="text-success h5 font-weight-normal">+9.314 €</span></li>
            <li class="d-flex justify-content-between"><span class="text-left">Costs</span><span class="h5 font-weight-normal">17.314 €</span></li>
          </ul>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  props: {
    overviewData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      viewWarnings: false,
      viewSolutions: false,
    }
  },

  computed: {
    percentDunot() {
      const withoutPercent = this.overviewData.contactsPercentageOfTotal && this.overviewData.contactsPercentageOfTotal.replace('%', '')
      return parseInt(withoutPercent)
    },
  },

  method: {
    toggleWarnings() {
      this.viewWarnings = !this.viewWarnings
    },

    toggleSolutions() {
      this.viewSolutions = !this.viewSolutions
    },
  },
}
</script>

<style scope lang="scss">
transition .c-switch-slider {
  background: #ccc;
}

.overview {
  position: relative;
  //TODO entender
  display: block;
  width: 100%;
  border-radius: 2px;
  box-shadow: 0px 9px 23.5px 0.5px rgba(34, 37, 43, 0.08);

  h1 {
    font-size: 50px;
  }

  .h-0 {
    height: 0;
  }

  .h-auto {
    height: auto;
  }

  &__toggle {
    cursor: pointer;
    &:hover {
      background: $gray-300;
    }
  }

  &__box:not(:last-child) {
    border-bottom: 1px solid $gray-200;
  }
}

$pie-size: 120px;
$donut-size: 7px;
$text-size: 40px;

@mixin translateX($x) {
  -webkit-transform: translateX($x);
  -ms-transform: translateX($x); // IE9 only
  -o-transform: translateX($x);
  transform: translateX($x);
}

@mixin rotate($degrees) {
  -webkit-transform: rotate($degrees);
  -moz-transform: rotate($degrees);
  -ms-transform: rotate($degrees); // IE9 only
  -o-transform: rotate($degrees);
  transform: rotate($degrees);
}

@mixin position-center() {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

@mixin horizontal-gradient($start-color, $end-color) {
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/ */
  background-image: $start-color; /* Old browsers */
  background-image: -moz-linear-gradient(left, $start-color 0%, $start-color 50%, $end-color 50%, $end-color 100%); /* FF3.6-15 */
  background-image: -webkit-linear-gradient(left, $start-color 0%, $start-color 50%, $end-color 50%, $end-color 100%); /* Chrome10-25,Safari5.1-6 */
  background-image: linear-gradient(
    to right,
    $start-color 0%,
    $start-color 50%,
    $end-color 50%,
    $end-color 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$start-color', endColorstr='$end-color',GradientType=1 ); /* IE6-9 */
}

.percentage-circle {
  @include horizontal-gradient($gray-200, $primary);
  position: relative;
  width: $pie-size;
  height: $pie-size;
  background-color: $gray-200;
  border-radius: 50%;
  &:before,
  &:after {
    content: '';
    display: block;
  }
  &:before {
    margin-left: 50%;
    height: 100%;
    transform-origin: left;
    border-radius: 0 100% 100% 0 / 50%;
  }
  &:after {
    @include position-center();
    border-radius: 50%;
    background: white;
    width: $pie-size - $donut-size;
    height: $pie-size - $donut-size;
    z-index: 10;
  }
  span {
    @include position-center();
    @include translateX(2px);
    display: block;
    width: 100%;
    height: $text-size;
    font-size: $text-size;
    line-height: 1;
    letter-spacing: 1px;
    text-align: center;
    z-index: 50;
    font-weight: 700;
  }
}

@for $i from 1 through 50 {
  .circle-#{$i} {
    &:before {
      $percentage: $i;
      $deg: ($percentage / 100) * 360deg;
      background-color: inherit;
      @include rotate($deg);
    }
  }
}

@for $i from 51 through 100 {
  .circle-#{$i} {
    &:before {
      $percentage: $i;
      $deg: (($percentage - 50) / 100) * 360deg;
      @include rotate($deg);
    }
    &.circle-basic {
      &:before {
        background-color: $primary;
      }
    }
  }
}
</style>
